/**
* ExtendedData defines model for Additional Statistics and Live Streaming data
* @typedef ExtendedData
* @type {Object}

*/

export type ExtendedDataType =
{
    eventId: number,

    linkURL: string,

    hasLiveStream: boolean,

    hasStatistics: boolean,

    statisticsInfo: StatisticsData
}

export class ExtendedData {

    eventId: number;

    linkURL: string;

    hasLiveStream: boolean;

    hasStatistics: boolean;

    statisticsInfo: StatisticsData;

    constructor(extendedData: ExtendedDataType) {

        this.eventId = extendedData.eventId;

        this.linkURL = extendedData.linkURL;

        this.hasLiveStream = extendedData.hasLiveStream;

        this.hasStatistics = extendedData.hasStatistics;

        this.statisticsInfo = extendedData.statisticsInfo;
    }

}